import CalendarEventsBulkDelete from "./CalendarEventsBulkDelete";
import CalendarEventsTable from "./CalendarEventsTable";
import useCalendarEventsWindow from "./useCalendarEventsWindow";

function CalendarEventsInfiniteTable({
    events,
    eventCategories,
    socket,
    eventsToBeDeleted,
    onDeleteEventsToBeDeleted,
    now,
}) {
    const {
        containerRef,
        visibleEvents,
        topSpacerHeight,
        bottomSpacerHeight,
        nowMoment,
        handleRowRef,
        handleScroll,
    } = useCalendarEventsWindow(events, now);

    return (
        <>
            <CalendarEventsBulkDelete
                events={events}
                eventsToBeDeleted={eventsToBeDeleted}
                onDeleteEventsToBeDeleted={onDeleteEventsToBeDeleted}
            />
            <CalendarEventsTable
                events={visibleEvents}
                eventCategories={eventCategories}
                socket={socket}
                eventsToBeDeleted={eventsToBeDeleted}
                containerRef={containerRef}
                onScroll={handleScroll}
                onRowRef={handleRowRef}
                topSpacerHeight={topSpacerHeight}
                bottomSpacerHeight={bottomSpacerHeight}
                now={nowMoment}
            />
        </>
    );
}

export default CalendarEventsInfiniteTable;
